<div fxLayout="column" fxFlexFill>
  <div fxFlex>
    <router-outlet></router-outlet>
  </div>
  <app-footer flex *ngIf="displayFooter"></app-footer>
</div>